// extracted by mini-css-extract-plugin
export var alternate = "image-and-text-module--alternate--ecfb5";
export var contentBlock = "image-and-text-module--contentBlock--eede8";
export var image = "image-and-text-module--image--c9b11";
export var reverse = "image-and-text-module--reverse--89bf7";
export var root = "image-and-text-module--root--7e678";
export var rtl = "image-and-text-module--rtl--57167";
export var wrapper = "image-and-text-module--wrapper--e8433";